import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Trip, TripStatus } from '../models/trip';
import { getFileNameFromResponseContentDisposition, checkIfTruncated, saveFile } from './utils/file-download-helper';

@Injectable()
export class TripsService {

  TRIP_URL = environment.serverUrl + "api/1/trips";

  constructor(private http: HttpClient) { }

  getFormattedUrl(pageIndex: number, itemPerPage: number,
    filters: Map<string, string>, criterias: Map<string, boolean>) {

    let offset = ((pageIndex - 1) * itemPerPage); // records offset to display the specific range

    let url = this.TRIP_URL + "?pagination=" + offset + "-" + itemPerPage + "&sorts=";

    if (criterias.size == 0) { // if no sorts criterias => sort by id
      url += "t.tripStartTime desc";
    } else {
      Array.from(criterias.keys()).forEach(c => url += c + (criterias.get(c) === true ? " asc" : " desc") + ",");
      url = url.substring(0, url.length - 1);
    }

    if (filters != undefined) {

      let filtersAsString = JSON.stringify(filters, (key, value) => {
        if (value !== null && value != undefined && value != "") return value
      });

      if (filtersAsString.length > 2) {
        url += "&filters=" + filtersAsString;
      }
    }
    return url;
  }

  getPaginatedFilteredSortedStations(pageIndex: number, itemPerPage: number,
    filters: Map<string, string>, criterias: Map<string, boolean>): Observable<any> {
    
    let url = this.getFormattedUrl(pageIndex, itemPerPage, filters, criterias);
    return this.http.get<any>(encodeURI(url), { observe: "response" }).map(response => {
      return {
        headers: response.headers,
        res: <any[]>response.body
      }
    }
    );
  }

  downloadXLSFile(pageIndex: number, itemPerPage: number, filters: Map<string, any>, criterias: Map<string, boolean>): any {
    let url = this.getFormattedUrl(pageIndex, itemPerPage, filters, criterias);
    return this.http.get<any>(encodeURI(url), {
      headers: { Accept: 'application/octet-stream' },
      responseType: 'blob' as 'json',
      observe: 'response'
    }).map((response) => {
      const fileName = getFileNameFromResponseContentDisposition(response, "trips.xls");
      const isTruncated = checkIfTruncated(response);
      saveFile(response.body.slice(), fileName);
      return isTruncated;
    });
  }


  get(tripId: number): Observable<Trip> {
    return this.http.get<Trip>(encodeURI(this.TRIP_URL + "/" + tripId));
  }

  closeAbnormally(trip: Trip, comment: string): Observable<any> {
    let t = new Trip();
    t.status = TripStatus.ABNORMALLY_TERMINATED;
    return this.http.patch(encodeURI(this.TRIP_URL + "/" + trip.id + "/" + comment), t);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/trips.service.ts